namespace GeniuzPOS.Product {
    export interface PsSetItemForm {
        StartDate: Serenity.DateEditor;
        FinishDate: Serenity.DateEditor;
        SetItemCode: Serenity.LookupEditor;
        SetItemName: Serenity.StringEditor;
        SetItemShortName: Serenity.StringEditor;
        SetItemUnit: Serenity.LookupEditor;
        SetPrice: Serenity.DecimalEditor;
        PsSetItemDtList: PsSetItemDtEditor;
        CalDtFg: Serenity.IntegerEditor;
    }

    export class PsSetItemForm extends Serenity.PrefixedContext {
        static formKey = 'Product.PsSetItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsSetItemForm.init)  {
                PsSetItemForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;
                var w4 = PsSetItemDtEditor;
                var w5 = s.IntegerEditor;

                Q.initFormType(PsSetItemForm, [
                    'StartDate', w0,
                    'FinishDate', w0,
                    'SetItemCode', w1,
                    'SetItemName', w2,
                    'SetItemShortName', w2,
                    'SetItemUnit', w1,
                    'SetPrice', w3,
                    'PsSetItemDtList', w4,
                    'CalDtFg', w5
                ]);
            }
        }
    }
}
